import { render, staticRenderFns } from "./icon-tick.vue?vue&type=template&id=31767d89"
import script from "./icon-tick.vue?vue&type=script&lang=ts"
export * from "./icon-tick.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports